import styled from 'styled-components'
import { rem } from 'polished'

import type { DetailItemCardVariant } from 'tripPlanner/components/DetailItemCard/common/types'
import type { ItemPinCategory } from './itemPinTypes'
import { getItemPinIcon } from './itemPinTypes'
import Caption from 'LuxKit/Typography/Caption'
import { setSvgIconSize } from 'LuxKit/SvgIcon'
import Group from 'components/utils/Group'

const IconContainer = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border-radius: ${props => props.theme.borderRadius.round};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  width: ${rem(20)};
  height: ${rem(20)};
  ${setSvgIconSize(10)};

  @container (min-width: 640px) {
    width: ${rem(28)};
    height: ${rem(28)};
    ${setSvgIconSize(14)};
  }
`

const NumberBadge = styled(Group)<{ color: string }>`
  border-radius: ${props => props.theme.borderRadius.round};
  background-color: ${props => props.color};
  width: ${rem(20)};
  height: ${rem(20)};

  @container (min-width: 640px) {
    width: ${rem(28)};
    height: ${rem(28)};
  }
`

interface Props {
  variant: DetailItemCardVariant
  category: ItemPinCategory
  itemNumber?: number
  dayColor?: string
}

export default function ItemPin({ variant, category, itemNumber, dayColor }: Props) {
  if (variant === 'drawer') {
    return null
  }

  if (itemNumber && dayColor) {
    return (
      <NumberBadge color={dayColor} direction="horizontal" verticalAlign="center" horizontalAlign="center">
        <Caption variant="medium" weight="bold" colour="neutral-eight">{itemNumber}</Caption>
      </NumberBadge>
    )
  }

  const IconComponent = getItemPinIcon(category)
  return (
    <IconContainer direction="horizontal" verticalAlign="center" horizontalAlign="center">
      <IconComponent />
    </IconContainer>
  )
}
